import moment from 'moment'
import EventBus from './event-bus'
import { isEmpty } from 'lodash'

export const TYPE_ERROR = 'error'
export const TYPE_WARNING = 'warning'
export const TYPE_INFO = 'info'
export const TYPE_DANGER = 'danger'
export const TYPE_SUCCESS = 'success'
export const OFFSET = 48

export default {
  methods: {
    /**
     *
     * @param parameters
     * @returns {Promise<void>}
     */
    async saveNotification(parameters) {
      this.$client.execute({
        operationId: 'Notification_saveNotification',
        parameters,
        requestContentType: 'application/x-www-form-urlencoded',
      })
    },

    /**
     *
     * @param title
     * @param text
     * @param params
     * @param type
     * @param duration
     * @param link
     * @param html
     * @param save
     * @param onClick
     * @param customClass
     * @param pushMessage
     * @param count
     * @returns {Promise<void>}
     */
    async showNotification({
      title,
      text,
      params = {},
      type,
      duration,
      link,
      html = false,
      save = true,
      onClick,
      customClass,
      pushMessage = false,
      count,
    }) {
      let message = text
      title = count && count > 1 ? `${this.$i18n.t(title)} (${count})` : this.$i18n.t(title)

      if (isEmpty(params)) {
        message = this.$i18n.t(message)
      } else {
        Object.keys(params).forEach((key) => {
          if (['label', 'errorText', 'warningText', 'formName'].includes(key)) {
            params[key] = this.$i18n.t(params[key])
          }
        })
        message = this.$i18n.interpolate(this.$i18n.t(message), params)
      }
      this.$notify({
        title,
        offset: OFFSET,
        dangerouslyUseHTMLString: html,
        message,
        type,
        duration,
        onClick,
        customClass,
      })

      if (!save) return

      const parameters = {
        title: text ? title : type,
        msg: text || title || '',
        idSUser: CORE.params.ID_S_USER,
        idSubsystem: CORE.subSystem.id,
        config: JSON.stringify({ type, duration }),
        readDate: moment().format(),
        pushMessage,
        type,
        link,
      }
      if (!isEmpty(params)) Object.assign(parameters, { params })

      await this.saveNotification(parameters)

      EventBus.$emit('refresh-notifications')
    },


    /**
     *
     * @param message
     * @return {*}
     */
    transformServerMessage(message) {
      const transformedMsg = { ...message }
      const messageType =
        message.config && message.config.type ? message.config.type.toLowerCase() : message.type.toLowerCase()
      let type

      switch (messageType) {
        case TYPE_ERROR:
          type = TYPE_ERROR
          break
        case TYPE_DANGER:
          type = TYPE_DANGER
          break
        case TYPE_WARNING:
          type = TYPE_WARNING
          break
        case TYPE_SUCCESS:
          type = TYPE_SUCCESS
          break
        default:
          type = TYPE_INFO
          break
      }

      Object.assign(transformedMsg, {
        text: message.msg,
        params: message.params || {},
        type,
      })

      return transformedMsg
    },
  },
}
